type Environment = "development" | "local" | "production" | "test";

export const ROLE_CONFIG = {
  admin: "admin",
  instructor: "instructor",
  student: "student",
  ta: "ta",
} as const;

export const ROLE_ALIASES: Record<string, string[]> = {
  admin: ["admin", "super_admin", "superadmin"],
  instructor: ["instructor"],
  student: ["student", "learner"],
  ta: ["ta", "teaching_assistant"],
};

export const normalizeRole = (role: string): string => {
  const lowerRole = role.toLowerCase();
  for (const [primaryRole, aliases] of Object.entries(ROLE_ALIASES)) {
    if (aliases.includes(lowerRole)) {
      return ROLE_CONFIG[primaryRole as keyof typeof ROLE_CONFIG];
    }
  }
  return role;
};

export const API_CONFIG = {
 development: import.meta.env.VITE_API_DEV_BASE_URL,
  test: import.meta.env.VITE_API_TEST_BASE_URL,
  local: import.meta.env.VITE_API_BASE_URL_LOCAL,
  production: import.meta.env.VITE_API_PROD_BASE_URL,
  image_url: import.meta.env.VITE_BASE_IMAGE_URL,
} as const;

export const AI_API_CONFIG = {
  development: import.meta.env.VITE_AI_API_DEV_BASE_URL || "http://localhost:8001",
  local: import.meta.env.VITE_AI_API_BASE_URL_LOCAL || "http://localhost:8001",
  production: import.meta.env.VITE_AI_API_BASE_URL || "/ai",
  test: import.meta.env.VITE_AI_API_BASE_URL || "/ai",
} as const;

export const AI_WS_CONFIG = {
  development: import.meta.env.VITE_AI_WS_DEV_URL || "ws://localhost:8001",
  local: import.meta.env.VITE_AI_WS_URL_LOCAL || "ws://localhost:8001",
  production: import.meta.env.VITE_AI_WS_URL || "/ai/ws",
  test: import.meta.env.VITE_AI_WS_URL || "/ai/ws",
} as const;

export const getCurrentEnvironment = (): Environment => {
  const env = (import.meta.env.VITE_API_NODE_ENV as string)?.trim() as Environment;
  return env || "development";
};

export const getBaseURL = (): string => {
  const env = getCurrentEnvironment();
  return API_CONFIG[env as keyof typeof API_CONFIG] || API_CONFIG.development || "/be";
};

export const getAIBaseURL = (): string => {
  const env = getCurrentEnvironment();
  return AI_API_CONFIG[env as keyof typeof AI_API_CONFIG] || AI_API_CONFIG.development || "/ai";
};

export const getAIWSURL = (): string => {
  const env = getCurrentEnvironment();
  return AI_WS_CONFIG[env as keyof typeof AI_WS_CONFIG] || AI_WS_CONFIG.development || "/ai/ws";
};

export const APP_CONFIG = {
  roles: ROLE_CONFIG,

  api: {
    baseURL: getBaseURL(),
    timeout: 120000,
    withCredentials: true,
  },

  features: {
    enableFeedback: true,
    enableAnalytics: false,
    enableDebugMode: getCurrentEnvironment() === "development",
  },

  app: {
    name: "Data Lab",
    version: "1.0.0",
  },
  internalApiToken: (import.meta.env.VITE_INTERNAL_API_TOKEN as string) || "local_dev_token",
} as const;

export const BASE_URL = getBaseURL();
